interface ToggleProps {
  on: boolean;
  onToggle: () => void;
}

export default function Toggle({ on, onToggle }: ToggleProps) {
  return (
    <button
      onClick={onToggle}
      className="relative w-11 h-6 rounded-full transition-colors duration-200 focus:outline-none flex-shrink-0"
      style={{ background: on ? "#C6D8A5" : "#d6cfc5" }}
    >
      <span
        className="absolute top-1 w-4 h-4 bg-white rounded-full shadow transition-all duration-200"
        style={{ left: on ? "22px" : "4px" }}
      />
    </button>
  );
}
